import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'engines',
});

export const engineDetailsRouteRef = createSubRouteRef({
  id: 'engine_detail',
  parent: rootRouteRef,
  path: '/:engine_udi',
});

export const siteEnginesRouteRef = createSubRouteRef({
  id: 'site_engines',
  parent: rootRouteRef,
  path: '/sites/:site_id',
});

export const siteRolloutsRouteRef = createSubRouteRef({
  id: 'site_rollouts',
  parent: rootRouteRef,
  path: '/sites/:site_id/rollouts',
});

export const siteApprovalRouteRef = createSubRouteRef({
  id: 'site_approval',
  parent: rootRouteRef,
  path: '/sites/:site_id/approval',
});

export const approvalsRouteRef = createSubRouteRef({
  id: 'approvals',
  parent: rootRouteRef,
  path: '/approvals',
});

export const engineFleetSettingsRouteRef = createSubRouteRef({
  id: 'engine_fleet_settings',
  parent: rootRouteRef,
  path: '/settings',
});

export const enginePortfolioRouteRef = createSubRouteRef({
  id: 'engine_portfolio',
  parent: rootRouteRef,
  path: '/portfolio',
});

export const engineSunsetRouteRef = createSubRouteRef({
  id: 'engine_sunset',
  parent: rootRouteRef,
  path: '/portfolio/sunset',
});

export const deployManifestRouteRef = createSubRouteRef({
  id: 'deploy_manifest',
  parent: rootRouteRef,
  path: '/:engine_udi/deploy-manifest',
});

export const deployManifestSiteModifiers = createSubRouteRef({
  id: 'engine_deploy_manifest_site_modifiers',
  parent: rootRouteRef,
  path: '/:engine_udi/deploy-manifest/:site_id/site-modifiers',
});

export const deployManifestSiteModifiersListRouteRef = createSubRouteRef({
  id: 'engine_deploy_manifest_site_modifiers_list',
  parent: rootRouteRef,
  path: '/:engine_udi/deploy-manifest/site-modifiers',
});

export const deployManifestEffectiveRouteRef = createSubRouteRef({
  id: 'engine_deploy_manifest_effective',
  parent: rootRouteRef,
  path: '/:engine_udi/deploy-manifest/effective/:site_id',
});

export const deployManifestRevisionsRouteRef = createSubRouteRef({
  id: 'engine_deploy_manifest_revisions',
  parent: rootRouteRef,
  path: '/:engine_udi/deploy-manifest/revisions',
});

export const deployManifestRevisionViewRouteRef = createSubRouteRef({
  id: 'engine_deploy_manifest_revision_view',
  parent: rootRouteRef,
  path: '/:engine_udi/deploy-manifest/revision/:revision',
});

export const deployManifestRevisionCompareRouteRef = createSubRouteRef({
  id: 'engine_deploy_manifest_revision_compare',
  parent: rootRouteRef,
  path: '/:engine_udi/deploy-manifest/revisions/:revision1/:revision2',
});

export const deployManifestConfigsRouteRef = createSubRouteRef({
  id: 'deploy_manifest_configs',
  parent: rootRouteRef,
  path: '/:engine_udi/deploy-manifest/configs',
});

export const deployManifestConfigRouteRef = createSubRouteRef({
  id: 'deploy_manifest_config',
  parent: rootRouteRef,
  path: '/:engine_udi/deploy-manifest/configs/:config_key',
});

export const engineQaRouteRef = createSubRouteRef({
  id: 'engine_qa',
  parent: rootRouteRef,
  path: '/:engine_udi/qa',
});

export const engineRevisionViewRouteRef = createSubRouteRef({
  id: 'engine_revision_view',
  parent: rootRouteRef,
  path: '/:engine_udi/revision/:revision',
});

export const engineRevisionsRouteRef = createSubRouteRef({
  id: 'engine_revisions',
  parent: rootRouteRef,
  path: '/:engine_udi/revisions',
});

export const engineRevisionCompareRouteRef = createSubRouteRef({
  id: 'engine_revision_compare',
  parent: rootRouteRef,
  path: '/:engine_udi/revisions/:revision1/:revision2',
});
